/**
 * WhatsApp sharing information
 * Shows that gift card will be shared on WhatsApp
 */
export function WhatsappSharingInfo() {
  return (
    <div class="flex h-8 items-center gap-2 stroke-text-normal-primary">
      <WhatsAppIcon />
      <span class="text-para-3-regular text-text-normal-primary">
        Gift card will be shared on WhatsApp as well
      </span>
    </div>
  );
}

function WhatsAppIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.481 18.7097L21.468 12.8777C22.177 12.5017 22.177 11.4897 21.468 11.1127L10.497 5.28969C9.669 4.84969 8.741 5.67969 9.092 6.54569L11.281 11.9457L9.074 17.4557C8.728 18.3227 9.655 19.1477 10.481 18.7097Z"
        class="stroke-inherit"
        stroke-width="1.5036"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.28 11.9496L22 11.9996"
        class="stroke-inherit"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 15H5.6"
        class="stroke-inherit"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 12H5.6"
        class="stroke-inherit"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2 9H5.6"
        class="stroke-inherit"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
